export default "__VITE_ASSET__BHaYQAPv__"